export const generateId = () => Math.floor(Math.random() * 1000000);